import { Component, computed, input } from '@angular/core';

type SpinnerType = 'default' | 'dual-ring' | 'facebook' | 'ring' | 'ellipsis' | 'grid' | 'ripple';
type SpinnerSize = 's' | 'm' | 'l';

@Component({
  selector: 'app-spinner',
  standalone: true,
  imports: [],
  templateUrl: './spinner.html',
  styleUrl: './spinner.scss',
})
export class Spinner {

  type = input<SpinnerType>('ring');
  size = input<SpinnerSize>('m');
  label = input<string>('Cargando…');

  ariaLabel = computed(() => this.label());

  scale = computed(() => {
    const s = this.size();
    return s === 's' ? 0.5 : s === 'l' ? 1.5 : 1;
  });
}
